/** Shared by the server, the browser bundle and vite.config.ts. */

export const CLIENT_PORT = 5173;
export const SERVER_PORT = 4320; // local only; Azure sets PORT

export const DEVICE_HEADER = 'x-aniimo-device';
export const ADMIN_HEADER = 'x-admin-key';

/** Reports older than this stop counting. A code that worked at launch says
 *  little a month later. */
export const VOTE_WINDOW_MS = 14 * 24 * 60 * 60 * 1000;

/** Reports needed before the working/broken split is worth showing. */
export const VERDICT_MIN_VOTES = 3;

/** Share of recent reports that must be failures to call a code broken. */
export const BROKEN_THRESHOLD = 0.6;
